import React from 'react';
import { Link } from 'react-router-dom';

export default function Page404() {
  return (
    <div className="Page404">
      <div className="page-content text-center">
        <img src={require('../../../assets/elfo-mascot-logo.png')} alt="..." />
        <h4 className="mt-2">Oops, you've lost</h4>
        <p>We can't find the page that you're looking for...</p>
        <Link className="btn btn-primary" to="/" style={{ display: 'inline-flex', minWidth: 160 }}>
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
